import { useIntl } from '@capsicum/common';
import { BaseCheckboxInput, Button, GenericDrawer, useRouter } from '@capsicum/common-web';
import { TabNames } from '@capsicum/features/wallet/shared';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

export type WarningFanTokenWithdrawDrawerProps = {
	close: () => void;
	testID: string;
};

export const WarningFanTokenWithdrawDrawer = ({ close, testID }: WarningFanTokenWithdrawDrawerProps) => {
	const { $t } = useIntl();
	const { push } = useRouter();
	const [isCheckboxChecked, setIsCheckboxChecked] = useState<boolean>(false);
	const [isContinueDisabled, setContinueDisabled] = useState<boolean>(true);

	useEffect(() => {
		setContinueDisabled(!isCheckboxChecked);
	}, [isCheckboxChecked, setContinueDisabled, isContinueDisabled]);

	const description = (
		<S.DescriptionWrapper>
			<S.RedContainer>{$t('wallet.withdraw.warningFanTokenWithdrawDrawer.text1')}</S.RedContainer>
			<a
				href="https://docs.chiliz.com/chiliz-chain-ecosystem#exchanges"
				rel="noopener noreferrer"
				target="_blank"
			>
				{$t('wallet.withdraw.warningFanTokenWithdrawDrawer.linkText')}
			</a>
			<div>{$t('wallet.withdraw.warningFanTokenWithdrawDrawer.text2')}</div>
			<div>
				<BaseCheckboxInput testID="withdraw-ftWarning-checkbox" onChange={setIsCheckboxChecked}>
					{$t('wallet.withdraw.warningFanTokenWithdrawDrawer.checkboxText')}
				</BaseCheckboxInput>
			</div>
			<S.ButtonWrapper>
				<Button
					color="destructive"
					disabled={isContinueDisabled}
					fullWidth
					testID="withdraw-warningFT-drawer-button"
					text={$t('global.button.continue')}
					variant="default"
					onClick={() => {
						close();
						push(`/wallet/withdraw/fantokens`);
					}}
				/>
				<Button
					color="neutral"
					testID="withdraw-warningFT-drawer-backButton"
					text={$t('wallet.withdraw.warningCHZWithdrawDrawer.backButtonText')}
					variant="text"
					onClick={() => {
						close();
						push(`/wallet?tab=${TabNames.FAN_TOKENS}`);
					}}
				/>
			</S.ButtonWrapper>
		</S.DescriptionWrapper>
	);

	const WarningFanTokenWithdrawDrawerData = {
		description: description,
		testID: testID,
		title: $t('wallet.withdraw.warningFanTokenWithdrawDrawer.title'),
		warning: true
	};

	return <GenericDrawer {...WarningFanTokenWithdrawDrawerData} />;
};

namespace S {
	export const DescriptionWrapper = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.medium};
		align-items: center;
		margin-top: ${({ theme }) => theme.spacings.xsmall};
	`;
	export const RedContainer = styled.div`
		color: ${({ theme }) => theme.colors.backgrounds.error.enabled};
	`;
	export const ButtonWrapper = styled.div`
		display: flex;
		position: sticky;
		background: ${({ theme }) => theme.colors.backgrounds.main.container};
		padding-top: ${({ theme }) => theme.spacings.large};
		bottom: 0;
		z-index: 9;
		align-self: center;
		width: 100%;
		align-items: center;
		justify-content: center;
		min-width: 100%;
		gap: ${({ theme }) => `${theme.spacings.xsmall}`};
		display: flex;
		flex-direction: column;
	`;
}
